import { h } from 'preact';
import Voucher from '../../../internal/Voucher';
import getIssuerImageUrl from '../../../../utils/get-issuer-image';
import { useCoreContext } from '../../../../core/Context/CoreProvider';
import { DragonpayVoucherResultProps } from '../../types';
import { VoucherDetail } from '../../../internal/Voucher/types';
import useImage from '../../../../core/Context/useImage';
import { extractCommonPropsForVoucher } from '../../../internal/Voucher/utils';

export default function DragonpayVoucherResult(props: DragonpayVoucherResultProps) {
    const { surcharge, expiresAt, alternativeReference, instructionsUrl, icon, issuer, paymentMethodType } = props;
    const { i18n } = useCoreContext();
    const getImage = useImage();
    const issuerImageUrl =
        paymentMethodType !== 'dragonpay_otc_philippines' ? getIssuerImageUrl({}, paymentMethodType, getImage)(issuer.toLowerCase()) : null;

    return (
        <Voucher
            {...extractCommonPropsForVoucher({ props, i18n, introKey: 'voucher.introduction', getImage: getImage() })}
            imageUrl={icon} // Can this url be different to the one generated by using the paymentMethodType?
            issuerImageUrl={issuerImageUrl}
            instructionsUrl={instructionsUrl}
            surcharge={surcharge && i18n.amount(surcharge.value, surcharge.currency)}
            voucherDetails={
                [
                    { label: i18n.get('voucher.expirationDate'), value: i18n.dateTime(expiresAt) },
                    { label: i18n.get('voucher.alternativeReference'), value: alternativeReference }
                ] as VoucherDetail[]
            }
            copyBtn
        />
    );
}
